import { render, staticRenderFns } from "./ProductsTemplate.vue?vue&type=template&id=69954c68&scoped=true&"
import script from "./ProductsTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69954c68",
  null
  
)

export default component.exports